import pendoBatcher from './pendoBatcher';

export const trackNavClick = (destination: string) => {
  pendoBatcher.addEvent('Navigation - Click', { destination });
};

export const trackDocsTabView = (tab: string) => {
  pendoBatcher.addEvent('API Docs - Tab View', { tab });
};
